export const PAIEMENT_STATUS_OPTIONS = [
    { text: "Tous", value: "" },
    { text: "Impayé", value: "1" },
    { text: "Payé", value: "0" }
]